import { render, staticRenderFns } from "./NewVisit.vue?vue&type=template&id=6b5cb0ce&"
import script from "./NewVisit.ts?vue&type=script&lang=ts&"
export * from "./NewVisit.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports